import { createAction, props } from '@ngrx/store';
import { CommunityProductCategory } from '../../models/community-product-category';

// Action to load community Category
export const loadCommunityProductCategory = createAction(
  '[Community Product Category] Load Community Product Category'
);

// Action to handle successful loading of community Category data
export const loadCommunityProductCategorySuccess = createAction(
  '[Community Product Category] Load Community Product Category Success',
  props<{ communityProductCategory: CommunityProductCategory[] }>() // Correct type reference, array of 'Category' objects
);

// Action to handle failure in loading community Category data
export const loadCommunityProductCategoryFailure = createAction(
  '[Community Product Category] Load Community Product Category Failure',
  props<{ error: any }>()
);
